import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "方式一：通过链接邀请", -1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "点击链接：", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "方式二：通过二维码邀请", -1)
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_app_qr_code = _resolveComponent("app-qr-code")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    class: "viewLinkModal",
    title: "查看链接",
    width: "800px",
    footer: null
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.record.enterpriseName), 1),
              _hoisted_4,
              _createTextVNode(" 邀请您使用能链企业版 "),
              _hoisted_5,
              _createTextVNode(" 加油更快捷，报销更方便"),
              _hoisted_6
            ]),
            _hoisted_7,
            _createElementVNode("a", {
              class: "link",
              target: "_blank",
              href: _ctx.record.url
            }, _toDisplayString(_ctx.record.url), 9, _hoisted_8)
          ]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onCopyUrl
          }, {
            default: _withCtx(() => [
              _createTextVNode("复制链接文字")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.record.enterpriseName), 1),
              _hoisted_12,
              _createTextVNode(" 邀请您使用能链企业版 "),
              _hoisted_13,
              _createTextVNode(" 加油更快捷，报销更方便"),
              _hoisted_14
            ]),
            _createVNode(_component_app_qr_code, {
              ref: "QrCodeRef",
              class: "qrcode",
              value: _ctx.record.url,
              size: 130,
              level: "M"
            }, null, 8, ["value"])
          ]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onDownloadQrcode
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载二维码")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}